/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationRelationShowPathParams,
	OrganisationRelationShowResponse,
} from '../types/OrganisationRelationShow'

/**
 * GET /organisations/:organisation
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::show
 */
export async function organisationRelationShow(
	organisation: OrganisationRelationShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationRelationShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}`, config)
}
